import * as React from "react";

interface IClient{
    img: string;
    content: string;
    name: string;
}

export class ClientItem extends React.Component<IClient, any>{
    constructor(props: IClient){
        super(props);
    }
    render(){
        return (
            <div className="ClientItem">
                <img className='ClientItem__photo' src={`./assets/images/${this.props.img}`} alt={this.props.img} />
                <p className='ClientItem__content'><i>{this.props.content}</i></p>
                <p className='ClientItem__name'><b>{this.props.name}</b></p>
            </div>
        )
    }
}

export default function OurClients(props: any) {
    return (
        <div className='OurClients'>
            <div className="container">
                <p className='InfoOurSite__title'><b>From our clients</b></p>
                <div className="OurClients__list">
                    <ClientItem 
                        img='p1.png'
                        content="I've been working with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola .."
                        name='Giannis'
                    />
                    <ClientItem 
                        img='p2.png'
                        content="I've been working with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola .."
                        name='Giannis'
                    />
                    <ClientItem 
                        img='p3.png'
                        content="I've been working with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola ..orking with Scola .."
                        name='Giannis'
                    />
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/homepage/OurClients.tsx